import { render, staticRenderFns } from "./RatInspectionDetail.vue?vue&type=template&id=93b7797a&scoped=true"
import script from "./RatInspectionDetail.vue?vue&type=script&lang=js"
export * from "./RatInspectionDetail.vue?vue&type=script&lang=js"
import style0 from "./RatInspectionDetail.vue?vue&type=style&index=0&id=93b7797a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b7797a",
  null
  
)

export default component.exports